import { useState } from "preact/hooks";
import { Byline } from "../chrome/byline.js";
import { dayLabel, remainingMinutes, ringLabel } from "../clock.js";
import { COVER_ID, seedSrc } from "../seed.js";
import { PHOTO_QUOTA, type DemoBrand, type DemoGuest } from "../types.js";

export interface InviteScreenProps {
  readonly brand: DemoBrand;
  readonly logoUrl: string | null;
  readonly accent: string;
  readonly photoCount: number;
  readonly current: number;
  readonly today: Date;
  readonly initial: DemoGuest | null;
  onJoin(guest: DemoGuest): void;
}

export function InviteScreen({
  brand,
  logoUrl,
  accent,
  photoCount,
  current,
  today,
  initial,
  onJoin,
}: InviteScreenProps) {
  const [first, setFirst] = useState(initial?.first ?? "");
  const [last, setLast] = useState(initial?.last ?? "");
  const valid = first.trim().length > 0 && last.trim().length > 0;
  return (
    <div class="d-screen d-invite" data-theme="dark" data-testid="screen-invite">
      <div class="d-cover">
        <img src={seedSrc(COVER_ID, "l")} alt="" />
        <span class="d-veil-soft" />
        <span class="d-veil-bottom" />
      </div>
      <div class="d-invite-column">
        <div class="d-invite-brand" style={{ borderBottomColor: accent }}>
          {logoUrl ? <img class="d-host-logo" src={logoUrl} alt="" /> : null}
          <span class="d-invite-host">Convidado por {brand.name}</span>
        </div>
        <p class="d-invite-headline">
          As fotos do evento, <em>por você</em>
        </p>
        <form
          class="d-card"
          data-theme="light"
          onSubmit={(event) => {
            event.preventDefault();
            if (valid) {
              onJoin({ first: first.trim(), last: last.trim() });
            }
          }}
        >
          <h1 class="d-card-title">{brand.eventName}</h1>
          <p class="d-invite-meta">
            {dayLabel(today)} · 19h00 · {photoCount} fotos
          </p>
          <p class="d-invite-clock">
            {ringLabel(remainingMinutes(current))} restantes · {PHOTO_QUOTA} fotos para você
          </p>
          <div class="d-names">
            <label class="d-label">
              <span>Nome</span>
              <input
                class="d-input"
                value={first}
                autocomplete="given-name"
                onInput={(event) => setFirst((event.currentTarget as HTMLInputElement).value)}
              />
            </label>
            <label class="d-label">
              <span>Sobrenome</span>
              <input
                class="d-input"
                value={last}
                autocomplete="family-name"
                onInput={(event) => setLast((event.currentTarget as HTMLInputElement).value)}
              />
            </label>
          </div>
          <button
            type="submit"
            class="d-button d-primary d-large"
            disabled={!valid}
            data-guide-target="invite"
          >
            Entrar no evento
          </button>
          <p class="d-caption">Sem instalar aplicativo. Você fotografa pelo navegador.</p>
        </form>
        <Byline onPhoto />
      </div>
    </div>
  );
}
